import React from 'react'
import NavBar from './NavBar'

export default function Home() {
  return (
    <div>
        <NavBar></NavBar>
      <h1>home</h1>
    </div>
  )
}
